import _Button from './Button';

import './style';

export type { ButtonProps } from './Button';
export * from './type';

export const Button = _Button;
export default Button;
